export const EstateType = {
  APARTMENT: `apartment`,
  HOUSE: `house`,
  HOTEL: `hotel`,
  ROOM: `room`,
};

export const CityName = {
  AMSTERDAM: `Amsterdam`,
  BRUSSELS: `Brussels`,
  COLOGNE: `Cologne`,
  DUSSELDORF: `Dusseldorf`,
  HAMBURG: `Hamburg`,
  PARIS: `Paris`,
};

export const MapType = {
  MAIN: `main`,
  DETAILS: `details`,
};

export const BookmarkStyle = {
  SMALL_BUTTON: `small`,
  BIG_BUTTON: `big`,
};

export const KeyCode = {
  ENTER: 13,
  SPACEBAR: 32,
};

export const OfferCardType = {
  MAIN: `main`,
  DETAILS: `details`,
  FAVORITES: `favorites`,
};

export const SortType = {
  POPULAR: 1,
  PRICE_LOW_TO_HIGH: 2,
  PRICE_HIGH_TO_LOW: 3,
  TOP_RATED_FIRST: 4,
};

export const AppRoute = {
  ROOM: `/offer/:id`,
  LOGIN: `/login`,
  FAVORITE: `/favorite`,
  ROOT: `/`,
};
